// services/frontend/src/utils/signupDraft.js

/**
 * [Why]
 * 웹 회원가입(3-step) 진행 중 입력값을 새로고침/뒤로가기에도 유지하기 위해
 * sessionStorage에 임시 저장하는 유틸입니다.
 *
 * [주의]
 * - 민감정보(비밀번호 등)가 포함될 수 있으므로 localStorage가 아닌 sessionStorage를 사용합니다.
 * - 운영 정책에 따라 추후 저장 범위를 축소하거나 암호화가 필요할 수 있습니다.
 */

const SIGNUP_DRAFT_KEY = 'signup_draft_v1';

export const getSignupDraft = () => {
  try {
    const raw = window.sessionStorage.getItem(SIGNUP_DRAFT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const setSignupDraft = (nextDraft) => {
  try {
  
    window.sessionStorage.setItem(SIGNUP_DRAFT_KEY, JSON.stringify(nextDraft || {}));
  } catch {
    // ignore
  }
};

export const patchSignupDraft = (partial) => {
  const prev = getSignupDraft() || {};
  const next = { ...prev, ...(partial || {}) };
  setSignupDraft(next);
  return next;
};

export const clearSignupDraft = () => {
  try {
    window.sessionStorage.removeItem(SIGNUP_DRAFT_KEY);
  } catch {
    // ignore
  }
};
